
import { Newsletter } from "../components/newsletter";
import { Partners } from "../components/partners";
import { ProductPage } from "../components/product";


function Product() {
  return (
    <>
      <ProductPage />
      <Partners />
      <Newsletter />
    </>
  )
}

export default Product;